module.exports = __webpack_public_path__ + "static/media/box-heart.c4c74c65.svg";